// ─────────────────────────────────────────────────────────────────────────────
// DOC-LIFECYCLE-001R1 (P1-A) — ID-NORMALISIERUNG.
// Backend-Vertrag: IDs (owner_id, document_id, verification_id, …) sind UUIDv4-Strings
// ODER numerisch-aussehende Legacy-Strings — IMMER als Strings behandeln. Number()-
// Vergleiche sind hier VERBOTEN: Number('a1111111-…') === NaN und NaN===NaN ist false,
// d. h. Owner-/Revisions-/Deep-Link-/Inbox-Zuordnung würde bei echten UUIDs still brechen
// (Geschwister nie gefunden, Inbox-Dubletten nie erkannt). Numerische Legacy-IDs bleiben
// als Strings kompatibel ('42' === String(42)).
// Getestet in admin-app/scripts/tests/doc-r1-helpers.test.mjs (node --test).
// ─────────────────────────────────────────────────────────────────────────────

// Normalisierte String-Form einer ID: nullish → null, sonst getrimmter String.
export function idStr(v) {
  if (v === null || v === undefined) return null;
  return String(v).trim();
}

// Gleichheit zweier IDs als Strings. Nullish auf EINER Seite ⇒ NIE gleich — kein
// versehentliches Zusammenlegen von Datensätzen ohne owner_id/id (String(null)==='null').
export function sameId(a, b) {
  const sa = idStr(a);
  const sb = idStr(b);
  if (sa === null || sb === null) return false;
  return sa === sb;
}

// Tiebreak „id DESC" wie das Backend (BINARY-Kollation) — deterministisch für UUID + Legacy,
// ohne NaN-Arithmetik. Als Array.sort-Comparator verwendbar.
export function compareIdDesc(a, b) {
  const sa = idStr(a) ?? '';
  const sb = idStr(b) ?? '';
  if (sa < sb) return 1;
  if (sa > sb) return -1;
  return 0;
}
